var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAccPassword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "21px",
    viewBox: "0 0 20 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAccPassword") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password--ERROR",
    transform: "translate(-40.000000, -241.000000)",
    stroke: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20.000000, 114.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Password",
    transform: "translate(20.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    strokeWidth: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42681885,8.81903076 C4.10773984,2.81852304 5.98795005,-0.119950093 10.0674495,0.00361135661 C14.1469489,0.127172806 15.9363554,3.06564594 15.4356689,8.81903076 L4.42681885,8.81903076 Z",
    id: "Path-15"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0.35,
    y: 8.92142857,
    width: 19.3,
    height: 10.7285714,
    rx: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10,16.9326782 C10.5522847,16.9326782 11,14.5522847 11,14 C11,13.4477153 10.5522847,13 10,13 C9.44771525,13 9,13.4477153 9,14 C9,14.5522847 9.44771525,16.9326782 10,16.9326782 Z",
    id: "Oval",
    strokeWidth: 0.5
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccPassword);
export default __webpack_public_path__ + "static/media/icAccPassword.fa8b10af4332c4564899b585964061f3.svg";
export { ForwardRef as ReactComponent };